import { TranslateModule } from '@ngx-translate/core';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';

import { MwDirectivesModule } from '@core/directives/directives.module';

import { MwAppModulesApiService } from './app-modules-api.service';
import { MwAppModulesComponent } from './app-modules.component';
import { MwAppModulesService } from './app-modules.services';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    TranslateModule,
    MwDirectivesModule,
  ],
  exports: [MwAppModulesComponent],
  declarations: [MwAppModulesComponent],
  providers: [MwAppModulesService, MwAppModulesApiService],
})
export class MwAppModulesModule {}
